import {EventIdSchema, NotificationIntegrationIdSchema} from '@cohort/shared/schema/apps';
import {asArray, DateSchema} from '@cohort/shared/schema/common';
import {
  notificationConfigurationResourceTypes,
  NotificationConfigurationResourceTypeSchema,
} from '@cohort/shared/schema/common/notificationConfiguration';
import {z} from 'zod';

export const NotificationConfigurationASchema = z.object({
  id: z.string().uuid(),
  merchantId: z.string().uuid(),
  userEventId: EventIdSchema,
  notificationIntegrationId: NotificationIntegrationIdSchema,
  notificationIntegrationConfig: z.unknown(),
  connectionId: z.string().uuid().nullable(),
  createdAt: DateSchema,
  resourceType: NotificationConfigurationResourceTypeSchema,
  resourceId: z.string().uuid().nullable(),
});
export type NotificationConfigurationADto = z.infer<typeof NotificationConfigurationASchema>;

export const CreateNotificationConfigurationASchema = z.object({
  userEventId: EventIdSchema,
  connectionId: z.string().uuid().nullable(),
  notificationIntegrationId: NotificationIntegrationIdSchema,
  notificationIntegrationConfig: z.unknown(),
  resourceType: NotificationConfigurationResourceTypeSchema,
  resourceId: z.string().uuid().optional(),
});
export type CreateNotificationConfigurationADto = z.infer<
  typeof CreateNotificationConfigurationASchema
>;

export const PatchNotificationConfigurationASchema = z
  .object({
    connectionId: z.string().uuid().nullable(),
    notificationIntegrationId: NotificationIntegrationIdSchema,
    notificationIntegrationConfig: z.unknown(),
  })
  .partial();
export type PatchNotificationConfigurationADto = z.infer<
  typeof PatchNotificationConfigurationASchema
>;

export const GetNotificationConfigurationResourceTypeSchema = z.union([
  z.literal('global'),
  z.enum(notificationConfigurationResourceTypes),
]);
export type GetNotificationConfigurationResourceTypeDto = z.infer<
  typeof GetNotificationConfigurationResourceTypeSchema
>;

export const GetNotificationConfigurationParamsASchema = z.object({
  userEventIds: z.preprocess(asArray, z.array(EventIdSchema)),
  resourceTypes: z.preprocess(asArray, z.array(GetNotificationConfigurationResourceTypeSchema)),
  resourceId: z.string().uuid().optional(),
});
export type GetNotificationConfigurationParamsADto = z.infer<
  typeof GetNotificationConfigurationParamsASchema
>;

export const DeleteNotificationConfigurationsParamsASchema = z.object({
  notificationConfigurationIds: z.preprocess(asArray, z.array(z.string().uuid())),
});
export type DeleteNotificationConfigurationsParamsADto = z.infer<
  typeof DeleteNotificationConfigurationsParamsASchema
>;
